import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MapScreen from './components/MapScreen.tsx'
import ReadmeScreen from './components/ReadMe.tsx';
import PrivacyPolicy from './components/PrivacyPolicy.tsx';
import { useEffect } from 'react';
import { requestPermision } from './firebase/firebase-init';
import NavBar from './components/NavBar.tsx';

function App() { 
  useEffect(() => {
    requestPermision();
  }, []);
  
  useEffect(() => {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  if (!gl) {
    alert('WebGL is not supported in this environment. Map cannot be displayed.');
  }
}, []);

  return (
    <Router>
      <NavBar />
      <Routes>
        <Route path="/" element={<MapScreen />} />
        <Route path="/readme" element={<ReadmeScreen />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;


